import React from 'react'
import { Container } from 'reactstrap'

const TermsPage = () => {
  return (
    <main className="min-vh-100 d-flex flex-column">
      <section className="py-5">
        <Container>
          <h1 className="display-5 fw-bold text-primary mb-4">Terms of Use</h1>
          <p className="text-muted mb-5">Last Revised Date: February 16, 2026</p>

          <div className="terms-content text-body-secondary">
            <p>
              These Terms of Use constitute a legal agreement by and between you and ColdBlock Technologies Inc. (“Coldblock Technologies”, “Company”, “we”, “us”, “our”). The following Terms of Use and our Privacy Policy (collectively the “Policies”), govern your access to and use of our Website and Client Portal (the “Service”) offered through or on <a href="https://www.coldblock.ca">www.coldblock.ca</a> (the “Website”).
            </p>
            <p className="fw-bold">
              BY USING OUR SERVICES, YOU ACKNOWLEDGE AND AGREE THAT YOU HAVE READ AND UNDERSTOOD THESE TERMS OF USE AND OUR PRIVACY POLICY, INCORPORATED HEREIN BY REFERENCE, AND AGREE TO BE BOUND BY THE POLICIES IN FULL. IF YOU DO NOT AGREE TO THE POLICIES, YOU SHOULD NOT ACCESS OR USE THE WEBSITE OR CLIENT PORTAL.
            </p>
            <p>
              We reserve the right and the sole discretion to revise and update these Terms of Use from time to time. Any and all changes are effective immediately upon posting the revised Terms of Use and will apply to continued access and use of our Services. BY CONTINUING TO USE THE SERVICES, YOU AGREE TO BE BOUND BY THE MOST RECENT VERSION OF THE TERMS OF USE.
            </p>
            <p>
              The information and material on the Website or Client Portal may be modified and/or withdrawn at any time without notice to you. YOU AGREE THAT COLDBLOCK TECHNOLOGIES WILL NOT BE LIABLE TO YOU IF, FOR ANY REASON, ALL OR PART OF THE WEBSITE IS RESTRICTED OR UNAVAILABLE TO USERS AT ANY GIVEN TIME OR PERIOD OF TIME.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">1. YOUR USE OF OUR SERVICE</h2>
            <p>
              These Terms of Use govern your access to and use of the Website and the Client Portal. Subject to your compliance with these terms, ColdBlock Technologies grants you a limited, non-transferable, non-exclusive, revocable right to access and use the Service for your personal, non-commercial use.
            </p>
            <p>
              ColdBlock Technologies does not grant you or any party any right, title, or interest in the Service. We reserve all rights not expressly granted to you under these Terms of Use.
            </p>
            <p>There are various types of users:</p>
            <ul>
              <li><strong>“Visitors”</strong> are those visiting the site</li>
              <li><strong>“Registered Users”</strong> have created an account which grants them access to certain additional services and information.</li>
            </ul>
            <p>
              All Visitors and Registered Users hereby warrant and represent that:
            </p>
            <ul>
              <li>Any information you provide to us shall be accurate, truthful, current, and complete;</li>
              <li>You shall not falsify your identity or impersonate any other person;</li>
              <li>You shall not use the Website or Client Portal for any unlawful, deceptive, misleading, fraudulent, or abusive purpose;</li>
              <li>You have the authority to enter into these Terms of Use; and</li>
              <li>You will comply with all Applicable Laws when using the Website or Client Portal.</li>
            </ul>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">2. RESTRICTIONS ON USE OF THE SERVICE</h2>
            <p>2.1 Except as permitted under this Terms of Use, you may not:</p>
            <ul>
              <li>Rent, lease, lend, sell, license, redistribute or sublicense the Website or Client Portal;</li>
              <li>Attempt to breach or breach the security safeguards measures;</li>
              <li>Modify any other site so as to falsely imply that it is associated with ColdBlock Technologies;</li>
              <li>Restrict, disrupt, or disable service to visitors, hosts, servers or networks;</li>
              <li>Introduce any malware such as viruses, trojan horses, worms, or logic bombs;</li>
              <li>Use the Website or Client Portal to violate the legal rights of others; and</li>
              <li>Take any action that imposes an unreasonable or disproportionately large load on our infrastructure.</li>
            </ul>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">3. INTELLECTUAL PROPERTY RIGHTS AND OWNERSHIP</h2>
            <p>
              3.1 You understand and agree that the entire contents of the Website and Client Portal is owned, controlled, or licensed by ColdBlock Technologies or its licensors and is protected by Canadian and International Intellectual Property Laws.
            </p>
            <p>
              3.2 The Company name “ColdBlock” and associated logo, are trademarks of the Company.
            </p>
            <p>
              3.3 All other trademark and service marks that appear on the Website that are not owned by ColdBlock Technologies are the property of their respective owners.
            </p>
            <p>
              3.4 You may only use the Website and Client Portal for your business needs. Nothing in this Terms of Use grants you any right, title, or interest in any intellectual property of ColdBlock Technologies or its licensors.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">4. USER CONTENT</h2>
            <p>
              4.1 In using the Client Portal, you may have the opportunity to upload or make available Informational User Content. When you upload Informational User Content on the Client Portal, you provide us with an irrevocable, non-exclusive, worldwide license to display such information on your Client Portal.
            </p>
            <p>
              4.2 In using our Website or Client Portal you may have the opportunity to upload or make available user testimonials. When you upload or provide such information, you grant ColdBlock Technologies an irrevocable, non-exclusive, sub-licensable, worldwide license to use and deal with such user testimonials.
            </p>
            <p>
              4.3 WE EXPRESSLY DISCLAIM ANY AND ALL LIABILITY OR RESPONSIBILITY IN CONNECTION WITH USER SUBMITTED CONTENT.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">5. PRIVACY</h2>
            <p>
              5.1 We will process personal information that you submit to us in accordance with our Privacy Policy. By continuing use of the Website and Client Portal, you agree with the ColdBlock Technologies <a href="https://coldblock.ca/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">6. THIRD-PARTY WEBSITES</h2>
            <p>
              6.1 Our Website may contain links to third-party websites that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, practices, or privacy policies of any third-party website.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">7. GEOGRAPHIC RESTRICTIONS</h2>
            <p>
              7.1 ColdBlock Technologies as the owner of the Services is based in Canada. If you access the Website from outside of Canada, you do so at your own risk and are responsible for any compliance with the laws of your jurisdiction.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">8. DISCLAIMERS</h2>
            <p>
              8.1 ColdBlock Technologies is not responsible for any errors, omissions, or inaccuracies on the Website or on any information uploaded to the Client Portal.
            </p>
            <p>
              8.2 YOU UNDERSTAND AND AGREE THAT YOUR USE OF THE WEBSITE, CLIENT PORTAL AND ANY CONTENT THEREIN IS AT YOUR OWN RISK. THE SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT ANY WARRANTIES OR CONDITIONS OF ANY KIND.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">9. LIMITATION OF LIABILITY</h2>
            <p>
              9.1 EXCEPT WHERE SUCH EXCLUSIONS ARE PROHIBITED BY LAW, COLDBLOCK TECHNOLOGIES WILL NOT BE LIABLE FOR ANY NEGLIGENCE, NEGLIGENT MISREPRESENTATION, OR DAMAGES OF ANY KIND RESULTING FROM USE OF THE WEBSITE, CLIENT PORTAL AND ANY CONTENT THEREIN.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">10. INDEMNIFICATION</h2>
            <p>
              10.1 You agree to indemnify, defend and hold harmless ColdBlock Technologies from and against any claims, losses, demands, judgements, actions, proceedings, damages, costs, expenses, and fees arising out of, or relating to (1) your breach of these Terms of Use, (2) your use or misuse of the Website and/or Client Portal, or (3) any violation of any third-party rights.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">11. GOVERNING LAW AND JURISDICTION</h2>
            <p>
              11.1 The Services and these Terms of Use will be governed, construed, and enforced in accordance with the laws of the Province of Ontario and the federal laws of Canada.
            </p>
            <p>
              11.2 Any cause of action or proceeding arising out of or relating to the Services and these Terms of Use will be instituted in the courts of the Province of Ontario and/or the Federal Court of Canada.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">12. SEVERABILITY</h2>
            <p>
              12.1 If any of the terms or provisions of these Terms of Use are found to be invalid, illegal or unenforceable, such findings shall not affect the validity, legality and enforceability of any other terms or provisions.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">13. SURVIVAL</h2>
            <p>
              13.1 Any terms or provisions of these Terms of Use, the performance of which is intended to survive by either party, shall survive the completion, termination, or cancellation of this Terms of Use.
            </p>

            <h2 className="h4 fw-bold text-primary mt-5 mb-3">14. CONTACT</h2>
            <p>
              14.1 For comments or communications related to the Website or Client Portal please contact us by email at <a href="mailto:info@coldblock.ca">info@coldblock.ca</a> or by phone at 1-833-423-0512.
            </p>
          </div>
        </Container>
      </section>
    </main>
  )
}

export default TermsPage
